import type { FormLoaderContext } from './types';
import { buildModuleRegistryMaps, type ModuleRegistryMaps } from './moduleRegistry';

let registryMaps: ModuleRegistryMaps | null = null;

export function createDefaultContext(): FormLoaderContext {
  if (registryMaps == null) {
    registryMaps = buildModuleRegistryMaps();
  }
  return {
    moduleDomain: new Map(registryMaps.moduleDomain),
    sharedModel: new Map(registryMaps.sharedModel),
    sharedOrch: new Map(registryMaps.sharedOrch),
    sharedRules: new Map(registryMaps.sharedRules),
  };
}

export function createEmptyContext(): FormLoaderContext {
  return {
    moduleDomain: new Map(),
    sharedModel: new Map(),
    sharedOrch: new Map(),
    sharedRules: new Map(),
  };
}

if (import.meta.hot) {
  import.meta.hot.on('schema:update', () => {
    registryMaps = null;
  });
}
